const yup = require("yup");

const progress = yup.object({
  fromsemester: yup.string().required("From semester is required"),
  tosemester: yup.string().required("To Semester  a required fields"),
  fromlevel: yup.string().required("From level is required"),
  tolevel: yup.string().required("To Level  a required fields"),
  fromsession: yup.string().required("From session is required"),
  tosession: yup.string().required("To Session  a required fields"),
});

module.exports = {
  progress,
};
